import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAvatar } from '@/util/util';
import { searchStaffFn } from 'api/org/per';
import { getCommonDepStaff } from 'api/common';
export default {
  // dataPrivilege 限制是否查看管辖范围之内的人员
  props: ['isRegister', 'comment', 'formalState', 'size', 'dataPrivilege'],
  data: function data() {
    return {
      supLoading: false,
      supOptions: [],
      res: {}
    };
  },
  methods: {
    // 生成员工头像姓名
    getAvatar: getAvatar,
    supRemoteMethod: function supRemoteMethod(query) {
      var _this = this;
      if (query.length) {
        this.supLoading = true;
        // ajax请求
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          if (_this.comment === 'comment') {
            var payload = _this.formalState ? {
              formal_state: 0,
              search_name: query
            } : {
              search_name: query
            };
            getCommonDepStaff(_objectSpread(_objectSpread({}, payload), {}, {
              data_privilege: _this.dataPrivilege
            })).then(function (res) {
              _this.supLoading = false;
              if (res && res.code === 1) {
                _this.supOptions = res.data.map(function (v) {
                  return {
                    avatar_url: v.avatar_url,
                    staff_name: v.staff_name,
                    staff_name_en: v.staff_name_en,
                    staff_name_th: v.staff_name_th,
                    staff_name_secondary: v.staff_name_secondary,
                    staff_id: v.staff_id,
                    staff_code: v.staff_code,
                    mobile: v.mobile
                  };
                });
              }
            });
          } else {
            searchStaffFn({
              search_name: query,
              page_size: 20,
              is_register_user: _this.isRegister,
              data_privilege: _this.dataPrivilege || 0
            }).then(function (res) {
              _this.supLoading = false;
              if (res && res.code === 1) {
                _this.supOptions = res.data.map(function (v) {
                  return {
                    avatar_url: v.avatar_url,
                    staff_name: v.staff_name,
                    staff_name_en: v.staff_name_en,
                    staff_name_th: v.staff_name_th,
                    staff_name_secondary: v.staff_name_secondary,
                    staff_id: v.staff_id,
                    staff_code: v.staff_code,
                    mobile: v.mobile
                  };
                });
              }
            });
          }
        }, 300);
      } else {
        this.supOptions = [];
      }
    },
    change: function change(val) {
      this.$emit('change', val || {
        staff_name: '',
        staff_id: '',
        staff_code: '',
        mobile: ''
      });
      this.$emit('input', val.staff_id || '');
    },
    clear: function clear() {
      this.supOptions = [];
    }
  }
};